export default __webpack_public_path__ + "static/media/person_2@2x.3ae79531.png";